// bill of ladings views
const BillOfLading = () => import("Modules/manufacturing/bill_of_ladings/views/BillOfLading");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "bill_of_lading/:id(\\d+)",
            name: "bill_of_lading",
            component: BillOfLading,
            meta: {
                requiresAuth: true,
                title: "lang.bill_of_lading",
                restrict_by_login_type: ["employee", "customer"],
            },
        },
    ],
};
